import { api } from "./api";

// ---------- Admin ----------
export async function fetchCursosAdmin() {
  const { data } = await api.get("/academia/admin/cursos");
  return data;
}

export async function subirArchivoAcademia(file, onProgress) {
  const form = new FormData();
  form.append("file", file);
  const { data } = await api.post("/academia/admin/upload", form, {
    headers: { "Content-Type": "multipart/form-data" },
    onUploadProgress: (e) => { if (onProgress && e.total) onProgress(Math.round((e.loaded * 100) / e.total)); },
  });
  return data; // { archivo_path, archivo_nombre, size }
}

export async function crearCurso(payload) {
  const { data } = await api.post("/academia/admin/cursos", payload);
  return data;
}
export async function actualizarCurso(id, payload) {
  const { data } = await api.put(`/academia/admin/cursos/${id}`, payload);
  return data;
}
export async function eliminarCurso(id) {
  await api.delete(`/academia/admin/cursos/${id}`);
}
export async function toggleEstadoCurso(id) {
  const { data } = await api.patch(`/academia/admin/cursos/${id}/estado`);
  return data;
}

// ---------- Usuario ----------
export async function fetchDetalleCurso(id) {
  const { data } = await api.get(`/academia/cursos/${id}`);
  return data;
}
export async function fetchMisCursos() {
  const { data } = await api.get("/academia/mis-cursos");
  return data;
}
export async function comprarCurso(id) {
  const { data } = await api.post(`/academia/${id}/comprar`, { origin_url: window.location.origin });
  return data;
}
export async function obtenerStreamUrl(cursoId, lid) {
  const { data } = await api.post("/academia/stream-link", { curso_id: cursoId, lid });
  const base = process.env.REACT_APP_BACKEND_URL || "";
  return `${base}${data.url}`;
}

export async function reportarProgreso(cursoId, lid, pct) {
  const { data } = await api.put(`/academia/cursos/${cursoId}/lecciones/${lid}/progreso`, { pct });
  return data; // { total_pct, completadas, total_lecciones, lecciones }
}

export async function concluirLeccion(cursoId, lid) {
  const { data } = await api.post(`/academia/cursos/${cursoId}/lecciones/${lid}/concluir`);
  return data; // { ok, total_pct, completadas, total_lecciones, graduado?, certificado? }
}

export async function descargarCertificado(cursoId) {
  const { data } = await api.get(`/academia/cursos/${cursoId}/certificado`, { responseType: "blob" });
  const url = URL.createObjectURL(new Blob([data], { type: "application/pdf" }));
  window.open(url, "_blank");
  setTimeout(() => URL.revokeObjectURL(url), 60000);
}

export async function verificarCertificado(codigo) {
  const { data } = await api.get(`/academia/certificados/verificar/${codigo}`);
  return data;
}

export async function fetchMisCertificados() {
  const { data } = await api.get("/academia/mis-certificados");
  return data.items || [];
}

export async function blobCertificadoPorCodigo(codigo) {
  const { data } = await api.get(`/academia/certificado/${codigo}/pdf`, { responseType: "blob" });
  return URL.createObjectURL(new Blob([data], { type: "application/pdf" }));
}

export async function blobCertificadoPrueba() {
  const { data } = await api.get(`/academia/certificado-prueba`, { responseType: "blob" });
  return URL.createObjectURL(new Blob([data], { type: "application/pdf" }));
}
